module.exports = __webpack_public_path__ + "img/reward.033cf53e.svg";